var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "flex-grid",
    { attrs: { "align-items": "center", "justify-content": "flex-end" } },
    [
      _c(
        "flex-grid-item",
        { attrs: { width: "102px" } },
        [
          _c("button-fill", {
            attrs: { color: "tertiary", label: "CANCEL" },
            on: { click: _vm.onCancelClick }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "flex-grid-item",
        [
          _c("button-fill", {
            attrs: { disabled: !_vm.submitEnabled, label: "APPLY" },
            on: { click: _vm.onSubmitClick }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-026d52b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-026d52b2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/settings-footer.vue
// module id = 1356
// module chunks = 0